module.exports = __webpack_public_path__ + "static/media/skoda-go-drive.c618a9c5.png";